import * as React from "react";
import * as ReactModal from "react-modal";
import classNames = require("classnames");

interface Props {
	/**
	 * Title of the modal.
	 */
	title?: string | JSX.Element;
	/**
	 * On close button clicked.
	 */
	onCloseClicked?: () => void;
	/**
	 * Optional subtitle for the header of the modal.
	 */
	subtitle?: string
	/**
	 * Indicates if modal should have auto width.
	 */
	autoWidth?: boolean
	/**
	 * Fixed width of the modal.
	 */
	fixedWidth?: boolean
	/**
	 * Fixed width of 40% of the screen.
	 */
	mediumWidth?: boolean
	/**
	 * Modal custom CSS class.
	 */
	customClass?: string;
	/**
	 * Indicates if default overflow properties of modal are disabled
	 */
	oveflowUnset?: boolean;
}

export default class Modal extends React.PureComponent<Props> {

	render() {
		const classFromProps = classNames({
			"c-modal-content": true,
			[`${this.props.customClass}`]: !!this.props.customClass,
		});
		return (
			<ReactModal
				isOpen={true}
				style={{content: this.getContentStyle(), overlay: overlayStyle}}
				contentLabel="Modal">
				<div className={classFromProps}>
					<div className={"c-modal-content_header"}>
						{this.props.onCloseClicked && <button type="button" className="close c-modal-close"
								data-dismiss="modal" aria-label="Close"
								onClick={this.props.onCloseClicked}>
							<span aria-hidden="true">&#10005;</span>
						</button>}
						{this.props.title &&
						<h3 className={"c-modal-title"}>{this.props.title}</h3>}
						{this.props.subtitle && <span className="c-modal-subtitle">{this.props.subtitle}</span>}
					</div>
					<div className={"c-modal-content_children"}>
						{this.props.children}
					</div>
				</div>
			</ReactModal>
		);
	}

	private getContentStyle() {
		let style = {
			border: "none",
			left: "",
			right: "",
			bottom: "",
			top: "",
			position: "relative",
			maxWidth: "80%",
			maxHeight: "90%",
			padding: 0,
			overflow: "hidden",
			overflowY: "auto",
		};

		if (this.props.oveflowUnset) {
			style = {...style, overflow: "unset", overflowY: "unset"}
		}

		// On a phone a share of the screen leaves too little room for any of the modals: they take the screen,
		// less a margin, whatever width they ask for, and always scroll - a modal taller than the screen
		// with nowhere to scroll cannot be finished there.
		if (window.matchMedia && window.matchMedia(PHONE_MEDIA_QUERY).matches) {
			return {...style, width: "calc(100vw - 16px)", maxWidth: "none", minWidth: 0, overflow: "hidden", overflowY: "auto"};
		}

		if (this.props.autoWidth) {
			return {...style}
		}
		else if (this.props.fixedWidth) {
			return {...style, width: "60%"}
		}
		else if (this.props.mediumWidth) {
			return {...style, width: "40%"}
		}
		else {
			return {...style, minWidth: "60%"}
		}
	}
}

/**
 * Screens narrow enough for a modal to take their full width; reactModal.scss uses the same width.
 */
const PHONE_MEDIA_QUERY = "(max-width: 640px)";

const overlayStyle = {
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	backgroundColor: "rgba(0,0,0,0.6)"
};
